import * as React from 'react';

import './style.css';
export default function Circles(){
    
    return (
        <div id="poster-circles" className='flex-column'>
            <div className="flex-row">
                <div className="circle circle-green">

                </div>
                <div className="circle circle-green">

                </div>
                <div className="circle circle-green">

                </div>
            </div>
            <div className="flex-row">
                <div className="circle circle-yellow">

                </div>
                <div className="circle circle-red">

                </div>
            </div>
        </div>
    )
}